import Page from "src/components/Report/Page";
import MiniSignalChart from "./components/MiniSignalChart";
import { useLocation } from "react-router-dom";

export default function Page17() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");

    let EVC;
    if (JSON.parse(localStorage?.data)?.[jobId]?.EVC) {
        EVC = JSON.parse(localStorage?.data)?.[jobId]?.EVC
    } else {
        EVC = []
    }
    let KSA;
    if (JSON.parse(localStorage?.data)?.[jobId]?.KSA) {
        KSA = JSON.parse(localStorage?.data)?.[jobId]?.KSA
    } else {
        KSA = []
    }
    return (
        <Page pageNumber={17}>
            <div className="font-bold text-lg">
                شاخص های رفتاری (EVC)
            </div>
            <div className="flex flex-col">

                {
                    Object.keys(EVC).sort(function (a, b) { return EVC[b].value - EVC[a].value }).map((key, index) => {
                        if (EVC[key].value >= 1) {
                            return (
                                <div className="flex items-center gap-3 odd-color">
                                    <MiniSignalChart value={EVC[key].value} />
                                    <div className=" px-2">{key}</div>
                                    {/* <div className="text-[13px]">{EVC[key].desc}</div> */}
                                </div>
                            )
                        }
                    })
                }
            </div>
            <div className="font-bold text-lg mt-10">
                شاخص های مبتنی بر شایستگی (KSA)
            </div>
            <div className="flex flex-col">

                {
                    Object.keys(KSA).sort(function (a, b) { return KSA[b].value - KSA[a].value }).map((key, index) => {
                        if (KSA[key].value >= 1) {
                            return (
                                <div className="flex items-center gap-3 odd-color">
                                    <MiniSignalChart value={KSA[key].value} />
                                    <div className=" px-2">{key}</div>
                                    {/* <div className="text-[13px]">{KSA[key].desc}</div> */}
                                </div>
                            )
                        }
                    })
                }
            </div>
        </Page>
    )
}